import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';

import { HttpErrorResponse } from '@angular/common/http';

import { APIURL } from 'app/Shared/Constant/API_Urls';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { ConfirmationService, MessageService } from 'primeng/api';

import { WhitespaceValidator } from 'app/Shared/Constant/whitespaces-validator';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { Select } from 'primeng/select';
import { AuthServiceService } from 'app/Authentification/auth-service.service';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
  imports: [ToastModule, FormsModule, ButtonModule,
    MatProgressSpinnerModule, TooltipModule, ReactiveFormsModule, ConfirmDialogModule,
    CommonModule, MatProgressSpinnerModule, Select, MultiSelectModule

  ]
})
export class AddUserComponent implements OnInit {

  @Input() rowData: any;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();

  isEditAction: any = false;

  userForm!: FormGroup;

  loading = false;

  clientNameListDropDown: any[] = [];
  rolesListDropDown: any[] = [];
  actions: any[] = [
    { label: 'Y', value: 'Y' },
    { label: 'N', value: 'N' }
  ];

  MPIDS: any[] = [];
  defaultFilterArray: any[] = [];
  userListDataset: any[] = [];

  showChangePassword = false;
  permanentPasswordEnabled = false;

  filterSearchText: string = '';
  showAddButton: boolean = false;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private authServiceService: AuthServiceService
  ) {

    this.userForm = this.fb.group({

      firstName: ['', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(256)
      ]],

      lastName: ['', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(256)
      ]],

      email: ['', [
        WhitespaceValidator.cannotContainSpace,
        Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$'),
        Validators.minLength(10),
        Validators.maxLength(256)
      ]],

      mpidSelectedGroup: [[], [Validators.required,]],

      clientIdSelectedGroup: [this.userService.activeMPID, Validators.required],
      roleSelectedGroup: ['User', Validators.required],
      activeDropdown: ['Y', Validators.required],

      mfaEnabled: [false],
      permanentPasswordEnabled: [false],
      password: [''],

      changePassword: [{ value: '', disabled: !this.permanentPasswordEnabled }, [
        Validators.minLength(8),
        Validators.pattern(ConstantService.passwordRegex)
      ]]
    },
    );
  }

  ngOnInit(): void {

    this.MPIDS = this.userService.getMPLIDList();
    this.getMPIDListDropDown();
    this.getRolesList();

    this.defaultFilterArray = [
      {
        isdefault: "true",
        label: "Date",
        columnname: "l.Created_Date",
        filterby: "IS",
        values: [new Date(), new Date()],
        datatype: "DateRange",
        disabled: "true"
      }
    ];

    let mpids = this.rowData?.mpids
    if (mpids) {
      mpids = mpids.split(',');
    }

    // patch edit data safely
    if (this.rowData) {
      this.userForm.patchValue({
        firstName: this.rowData?.firstName,
        lastName: this.rowData?.lastName,
        email: this.rowData?.userName,
        mpidSelectedGroup: mpids,
        roleSelectedGroup: this.rowData?.roleName,
        activeDropdown: this.rowData?.active,
        clientIdSelectedGroup: this?.rowData.clientName,
        changePassword: this.rowData?.changePassword,
        mfaEnabled: this.rowData?.mfaEnabled || false,
        permanentPasswordEnabled: false
      });
    }
    this.isEditAction = false;
    this.getData();
  }


handleFilter(event: any) {
    this.filterSearchText = event.filter || '';
    if (this.filterSearchText.trim() === '') {
      this.showAddButton = false;
      return;
    }
    const exists = this.clientNameListDropDown.some(
      item => item.value.toUpperCase() === this.filterSearchText.trim().toUpperCase()
    );
    this.showAddButton = !exists;
  }

   addNewMPIDValue(newValue: string, multiselectInstance: MultiSelect) {
    if (!newValue || newValue.trim() === '') return;
    const formattedValue = newValue.trim().toUpperCase(); 
    const exists = this.clientNameListDropDown.some(
      item => item.value.toUpperCase() === formattedValue
    );
    if (!exists) {
      const newItem = {
        label: formattedValue,
        value: formattedValue
      };
      this.clientNameListDropDown = [...this.clientNameListDropDown, newItem];
      const currentSelection = this.userForm.get('mpidSelectedGroup')?.value || [];
      this.userForm.get('mpidSelectedGroup')?.setValue([...currentSelection, formattedValue]);
      this.userForm.get('mpidSelectedGroup')?.markAsDirty();
    }
    this.filterSearchText = '';
      this.showAddButton = false;
    multiselectInstance.filterValue = '';
    if ('_filterValue' in multiselectInstance && typeof (multiselectInstance as any)._filterValue !== 'function') {
      (multiselectInstance as any)._filterValue = '';
    }
    multiselectInstance.resetFilter(); 
  }


  toggleChangePassword() {
    this.showChangePassword = !this.showChangePassword;
  }


  onMfaToggle(event: any): void {
    this.userForm.patchValue({
      mfaEnabled: event.target.checked
    });
  }

  onPasswordToggle(event: any): void {
    this.userForm.patchValue({
      permanentPasswordEnabled: event.target.checked
    });
    this.permanentPasswordEnabled = event.target.checked;
    const control = this.userForm.get('changePassword');
    if (this.permanentPasswordEnabled) {
      control?.enable();
      control?.setValidators([
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(ConstantService.passwordRegex)
      ]);
      control?.updateValueAndValidity();

    } else {
      this.userForm.value.changePassword = "";
      control?.reset();
      control?.clearValidators();
      control?.disable();
    }
    control?.updateValueAndValidity();
  }

  getUserMPIDList(): void {
    this.userService.getUserMPIDList(this.rowData?.userName)
    .subscribe({
      next: (response: any) => {
        const dataSet = response?.mpidList || [];
        if (dataSet) {
          this.MPIDS= dataSet.split(',');
          this.getMPIDListDropDown();
        }
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'MPID',
          detail: 'Failed to load user mpid list'
        });
      }
    });
  }

  getMPIDListDropDown(){
    if(this.MPIDS && this.MPIDS.length > 0){
      this.clientNameListDropDown = [];
      this.MPIDS.forEach((item: any) => {
      let mpid = item?.mpid || item;
      this.clientNameListDropDown.push({
        label: mpid,
        value: mpid
      });
    });
    }
  }

  getRolesList(): void {
    this.sharedHttpClientService.post(
    this.urlsService.setAPIURl(APIURL.getRolesList),
      { mpid: this.userService.getActiveMPID() }
    ).subscribe({
      next: (response: any) => {
        this.rolesListDropDown = [];

        const dataSet = response?.data?.[0] || [];

        dataSet.forEach((role: any) => {
          this.rolesListDropDown.push({
            label: role,
            value: role
          });
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Roles',
          detail: 'Failed to load roles'
        });
      }
    });
  }

  getData(): void {
    
    if (!this.rowData) {
      return;
    }
    this.getUserMPIDList();
    this.isEditAction = true;
    const control = this.userForm.get('email');
    control?.disable();

    const payload = {
      mpid: this.userService.getActiveMPID(),
      data: this.defaultFilterArray,
      userId: String(this.rowData['userId'])
    };

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.getUserDetail),
      payload
    ).subscribe({
      next: (res: any) => {

        this.userListDataset = res.data || [];

        if (this.userListDataset.length > 0) {
          const user = this.userListDataset[0];

          this.userForm.patchValue({
            roleSelectedGroup: user.Role_Description,
            email: user.emailID,
            firstName: user.firstName,
            lastName: user.lastName,
            permanentPasswordEnabled: false
          });
        }
      },
      error: () => {
        this.loading = false;
      }
    });
  }


  addUser(): void {
    this.loading = true;
    let mpidList = this.userForm.value?.mpidSelectedGroup.join(',')
    mpidList = mpidList.replace(/\s*,\s*/g, ',')
    let activityPaylod = {
      userName: this.userForm.value?.firstName + " " + this.userForm.value?.lastName,
      clientName: this.userForm.value?.clientIdSelectedGroup,
      roleName: this.userForm.value?.roleSelectedGroup,
      firstName: this.userForm.value?.firstName,
      lastName: this.userForm.value?.lastName,
      emailID: this.userForm.value?.email,
      active: this.userForm.value?.activeDropdown,
      mfaEnabled: this.userForm.value?.mfaEnabled,
      permanentPasswordEnabled: this.userForm.value?.permanentPasswordEnabled,
      isAdmin: this.userForm.value?.roleSelectedGroup == 'System_Admin' ? "Y" : "N",
      mpids: mpidList,
      createdBy: this.userService?.userFirstName,
      lastUpdatedBy: this.userService?.userFirstName,
    };
    this.userService.logUserActivity("Admin - Add New User ", null, {
      'Text1': 'Adding new user:' + this.userForm.value?.email,
      'Text2': 'Payload: ' + JSON.stringify({ activityPaylod })
    });
    this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.saveUserData), activityPaylod).subscribe({
      next: (res: any) => {
        if (res?.status) {
          const payload = {
            users: [
              {
                userName: this.userForm.value?.firstName + " " + this.userForm.value?.lastName,
                clientName: this.userForm.value?.clientIdSelectedGroup,
                roleName: this.userForm.value?.roleSelectedGroup,
                firstName: this.userForm.value?.firstName,
                lastName: this.userForm.value?.lastName,
                emailID: this.userForm.value?.email,
                mfaEnabled: this.userForm.value?.mfaEnabled,
                permanentPasswordEnabled: this.userForm.value?.permanentPasswordEnabled,
                password: this.userForm.value?.changePassword,
                active: this.userForm.value?.activeDropdown,
                loginFlag: "N",
                isAdmin: this.userForm.value?.roleSelectedGroup == 'System_Admin' ? "Y" : "N",
                mpids: this.userForm.value?.mpidSelectedGroup,
                createdBy: this.userService?.userFirstName,
                lastUpdatedBy: this.userService?.userFirstName,
              }
            ]
          }

          this.authServiceService.mfa_addUser(
            payload
          ).subscribe({
            next: (res: any) => {
              this.loading = false;
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res?.message || 'User saved successfully'
              });
              this.userService.logUserActivity("Admin - Add New User ", null, {
                'Text1': 'Added new user:' + this.userForm.value?.email,
                'Text2': 'Payload: ' + JSON.stringify(activityPaylod)
              });
              this.resetForm();
            },
            error: (err: HttpErrorResponse) => {
              this.loading = false;
              let error = err?.error?.message || 'Failed to save user';
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error
              });
  
              this.userService.logUserActivity("Cognito - Add New User ", null, {
                'Text1': 'Failed Error Occured :' + err?.error?.message,
                'Text2': 'Payload: ' + JSON.stringify({ activityPaylod })
              });
            }
          });
        } else {
          this.loading = false
        }

      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to save user'
        });
        this.userService.logUserActivity("Admin - Add New User ", null, {
          'Text1': 'Failed Error Occured :' + err?.error?.message,
          'Text2': 'Payload: ' + JSON.stringify({ activityPaylod })
        });
      }
    });
  }


  updateUser(): void {
    this.loading = true;
    let mpidList = this.userForm.value?.mpidSelectedGroup.join(',')
    mpidList = mpidList.replace(/\s*,\s*/g, ',')
    let activityPaylod = {
      userName: this.userForm.value?.firstName + " " + this.userForm.value?.lastName,
      clientName: this.userForm.value?.clientIdSelectedGroup,
      roleName: this.userForm.value?.roleSelectedGroup,
      firstName: this.userForm.value?.firstName,
      lastName: this.userForm.value?.lastName,
      emailID: this.rowData?.userName,
      active: this.userForm.value?.activeDropdown,
      mfaEnabled: this.userForm.value?.mfaEnabled,
      permanentPasswordEnabled: this.userForm.value?.permanentPasswordEnabled,
      isAdmin: this.userForm.value?.roleSelectedGroup == 'System_Admin' ? "Y" : "N",
      mpids: mpidList,
      createdBy: this.userService?.userFirstName,
      lastUpdatedBy: this.userService?.userFirstName,
    };
    this.userService.logUserActivity("Admin - Update User Details ", null, {
      'Text1': 'Updating User Details:' + this.userForm.value?.email,
      'Text2': 'Payload: ' + JSON.stringify({ activityPaylod })
    });

    const payload = {
      user:
      {
        userName: this.userForm.value?.firstName + " " + this.userForm.value?.lastName,
        clientName: this.userForm.value?.clientIdSelectedGroup,
        roleName: this.userForm.value?.roleSelectedGroup,
        firstName: this.userForm.value?.firstName,
        lastName: this.userForm.value?.lastName,
        emailID: this.rowData?.userName,
        mfaEnabled: this.userForm.value?.mfaEnabled,
        permanentPasswordEnabled: this.userForm.value?.permanentPasswordEnabled,
        password: this.userForm.value?.changePassword,
        active: this.userForm.value?.activeDropdown,
        loginFlag: "N",
        isAdmin: this.userForm.value?.roleSelectedGroup == 'System_Admin' ? "Y" : "N",
        mpids: this.userForm.value?.mpidSelectedGroup,
        createdBy: this.userService?.userFirstName,
        lastUpdatedBy: this.userService?.userFirstName,
      }
    }

    this.authServiceService.mfa_updateUser(
      payload
    ).subscribe({
      next: (res: any) => {
        if (res?.status) {
          this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.saveUserData), activityPaylod).subscribe({
            next: (res: any) => {
              if (res?.status) {
                this.loading = false;
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: res?.message || 'User updated successfully'
                });
                this.userService.logUserActivity("Admin - Update User Details ", null, {
                  'Text1': 'Updated User Details:' + this.userForm.value?.email,
                  'Text2': 'Payload: ' + JSON.stringify(activityPaylod)
                });
                this.closeDialog.emit(true);
              } else {
                this.loading = false
                this.closeDialog.emit(true);
              }
            },
            error: (err: HttpErrorResponse) => {
              this.loading = false;
              this.closeDialog.emit(false);
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to update user'
              });
              this.userService.logUserActivity("Admin - Update User Details ", null, {
                'Text1': 'Failed Error Occured :' + res?.message,
                'Text2': 'Payload: ' + JSON.stringify({ activityPaylod })
              });
            }
          });
        } else {
          this.loading = false;
          this.closeDialog.emit(false);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update user'
          });
          this.userService.logUserActivity("Admin - Update User Details ", null, {
            'Text1': 'Failed Error Occured :' + res?.message,
            'Text2': 'Payload: ' + JSON.stringify({ activityPaylod })
          });
        }
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.closeDialog.emit(false);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update user details'
        });
        this.userService.logUserActivity("Cognito - Update User Details ", null, {
          'Text1': 'Failed Error Occured :' + err?.error?.message,
          'Text2': 'Payload: ' + JSON.stringify({ activityPaylod })
        });
      }
    });
  }


  resetForm(): void {
    this.userForm.reset({
      mfaEnabled: false
    });
  }

  selectRole(e: any): void {
    this.userForm.patchValue({
      roleSelectedGroup: e.value
    });
  }

  selectClientName(e: any): void {
    this.userForm.patchValue({
      clientIdSelectedGroup: e.value
    });
  }

  selectActive(e: any): void {
    this.userForm.patchValue({
      activeDropdown: e.value
    });
  }

  ngOnDestroy() {
    // alert("destored edit")
  }
}